"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KdmMeetingDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const meeting_entity_1 = require("./meeting.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let KdmMeetingDocumentMap = class KdmMeetingDocumentMap {
};
exports.KdmMeetingDocumentMap = KdmMeetingDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], KdmMeetingDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], KdmMeetingDocumentMap.prototype, "meetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "kdm_meeting_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], KdmMeetingDocumentMap.prototype, "kdmMeetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], KdmMeetingDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => meeting_entity_1.Meeting, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "meeting_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof meeting_entity_1.Meeting !== "undefined" && meeting_entity_1.Meeting) === "function" ? _a : Object)
], KdmMeetingDocumentMap.prototype, "meeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof file_upload_entity_1.FileUpload !== "undefined" && file_upload_entity_1.FileUpload) === "function" ? _b : Object)
], KdmMeetingDocumentMap.prototype, "document", void 0);
exports.KdmMeetingDocumentMap = KdmMeetingDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "kdm_meeting_document_map" })
], KdmMeetingDocumentMap);
